import { CloudDownloadOutlined } from "@ant-design/icons";
import { Button, Space, Tooltip } from "antd";
import useDownloadButton from "../../hooks/useDownloadButton";

interface IProps {
  datasetId: string;
  text: string;
  record: any;
  index: any;
  path?: string;
}

const DownloadButton = (props: IProps) => {
  const { datasetId, record, index, path } = props;
  const { handleOnClick, currentkey } = useDownloadButton(
    datasetId,
    record,
    index,
    path
  );

  return (
    <Space>
      <Tooltip placement="top" title={<span>Download</span>}>
        <Button
          type="text"
          shape="circle"
          icon={<CloudDownloadOutlined />}
          className="btn-table"
          style={{ marginRight: 5 }}
          onClick={() => handleOnClick(path)}
          loading={currentkey === record.key ? true : false}
        />
      </Tooltip>
    </Space>
  );
};
export default DownloadButton;
